<template>
    <div class="container animated slideInDown">
        <div class="close" v-if="newsOpen" @click="closeNews"><i class="iconfont icon-guanbi"></i></div>
        <div class="main-title" @click="newsOpen = true">资讯中心</div>
        <div class="sub-title">News</div>
        <div class="news-list">
            <div class="left-list animated" :class="{'fadeOut':newsOpen,'fadeIn':!newsOpen}">
                <div class="news-container"
                     @click="openNews(item.id,index)" :key="'news_'+index"
                     v-for="(item,index) in newsList">
                    <div class="news-content">
                        <div class="news-title">{{item.title}}</div>
                        <div class="sub-info">
                            {{item.title}} {{item.title}} {{item.title}} {{item.title}}
                        </div>
                        <div class="date">{{item.created_at}}</div>
                    </div>
                    <div class="thumb" v-if="!newsOpen">
                        <img width="100%"
                             :src="item.cover_pic"
                             alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="right-content animated" v-if="newsOpen" :class="{'fadeIn':newsOpen}">
            <div class="details-title">{{details.title}}</div>
            <div class="details-sub-info">
                <span>{{details.created_at}}</span>
                <span>来源:{{details.from ||'非遗中心'}}</span>
                <span>作者:{{details.author ||'非遗中心'}}</span>
            </div>
            <div class="details-content" v-html="details.content">
            </div>
            <loading v-if="loading"></loading>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import scene1 from "@/assets/images/scene1.png"
    import scene2 from "@/assets/images/scene2.png"
    import scene3 from "@/assets/images/scene3.png"

    export default {
        name: "news",
        data() {
            return {
                scene1, scene2, scene3,
                newsOpen: false,
                newsList: [],
                loading: false,
                details: {}
            }
        },
        methods: {
            openNews: function (id, index) {
                this.newsOpen = true;
                this.loading = true;
                this.newsList.forEach((row, newsIndex) => {
                    row.selected = index === newsIndex;
                });
                this.details.content = "";
                this.$http.request('newsDetails', {id: id}).then(res => {
                    this.details = res.data;
                    this.loading = false;
                });
            },
            closeNews:function () {
                this.newsOpen = false;
            },
            getNews: function () {
                this.$http.request('newsList').then(res => {
                    res.data.forEach(row => {
                        row.selected = false;
                    });
                    this.newsList = res.data;
                });
            }
        },
        created: function () {
            this.getNews();
        },
        computed: {
            ...mapGetters([
                'component', 'baseConfig'
            ]),
        }
    }
</script>

<style scoped lang="less">
    .container {
        width: 1100px;
        background: rgba(255, 255, 255);
        padding: 30px 50px;
        margin: auto;
        height: 80vh;
        border-radius: 10px;
        position: relative;
        .close{
            position: absolute;
            width: 40px;
            height: 40px;
            line-height: 40px;
            border-radius: 100px;
            background: #eee;
            right: 20px;
            top:20px;
            text-align: center;
            cursor: pointer;
        }
        .main-title {
            width: 300px;
            border-bottom: 1px solid #000;
            font-size: 26px;
        }
        .sub-title {
            font-size: 20px;
            padding-top: 10px;
        }
        .news-list {
            display: flex;
            padding-bottom: 20px;
            height: 90%;
            .left-list {
                width: 100%;
                height: 100%;
                transition: all .3s ease;
                overflow: scroll;
                padding-right: 40px;
                .news-container {
                    border-bottom: 1px solid #e1e1e1;
                    display: flex;
                    padding:20px;
                    cursor: pointer;
                    position: relative;
                    .arrow{
                        width: 50px;
                        height: 50px;
                        position: absolute;
                        right: -25px;
                        transform: rotate(45deg);
                        top:40%;
                    }
                    .arrow-active{
                        background: #FFDBC5;
                    }
                    .news-content {
                        flex-grow: 1;
                        .news-title {
                            font-size: 16px;
                        }
                        .sub-info {
                            font-size: 12px;
                            color: #5f5f5f;
                            margin-top: 20px;
                        }
                        .date {
                            margin-top: 100px;
                            font-size: 12px;
                            color: #787878;
                        }
                    }
                    .thumb {
                        flex-grow: 1;
                        text-align: right;
                        padding-left: 20px;
                        img {
                            width: 300px;
                            height: 200px;
                        }
                    }
                }
                .news-container-active {
                    background: #FFDBC5;
                }
            }
            .left-list-active {
                width: 0;
                padding:0;
            }
        }
        .right-content {
            width: 90%;
            height: 630px;
            overflow: hidden;
            transition: all .3s ease;
            position: absolute;
            top:100px;
            left:0;
            right: 0;
            margin:auto;
            z-index:10;
            background: #fff;
            .details-title {
                text-align: center;
                font-size: 18px;
            }
            .details-sub-info{
                padding:20px 0;
                font-size: 12px;
                color: #535353;
                margin-bottom: 20px;
                border-bottom: 1px solid #000;
                span{
                    margin-right: 30px;
                }
            }
            .details-content {
                overflow: scroll;
                font-size: 13px;
                height: 560px;
                padding: 0 20px;
                img{
                    max-width: 100%;
                }
            }
        }
    }
</style>